import { Grid, Typography } from "@mui/material";
import { SignalsTemporalLabels } from "components/Signals/SignalsModels";
import moment from "moment";
import theme from "Theme/AppTheme";
import { getXDateRangeLabel } from "./dateBucketLabels";

export const dataPointTooltipBuilder = (args: {
    x: string | number | null;
    y: string | number | null;
    series: string | null;
    isTemporal: boolean;
    tempGrain: SignalsTemporalLabels;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isPercent?: boolean;
    title?: string;
    // Shown under the percent as "count/total eligible conversations"
    eligibleConversations?: { count: number; total: number };
}) => {
    const yValueFontSize = "34px";
    const yComponent = (
        <Typography
            style={{
                fontSize: yValueFontSize,
                color: theme.palette.blue.main,
            }}
        >
            {args.isPercent
                ? Number(args.y).toFixed(1) + "%"
                : Number(args.y).toLocaleString()}
        </Typography>
    );
    const subtitle = args.isTemporal
        ? getXDateRangeLabel(
              args.x,
              args.tempGrain,
              args.startDate,
              args.endDate,
          )
        : args.x;
    const title = args.title ?? (!!args.series ? args.series : subtitle);

    const titleComponent = (
        <Typography style={{ fontWeight: 600, fontSize: "14px" }}>
            {title}
        </Typography>
    );

    const subTitleComponent = !!args.series ? (
        <Typography style={{ fontSize: "14px" }}>
            {args.isTemporal
                ? getXDateRangeLabel(
                      args.x,
                      args.tempGrain,
                      args.startDate,
                      args.endDate,
                  )
                : args.x}
        </Typography>
    ) : null;

    const eligibleComponent = args.eligibleConversations ? (
        <Typography
            style={{ fontSize: "14px", color: theme.palette.gray[600] }}
        >
            {`${args.eligibleConversations.count.toLocaleString()}/${args.eligibleConversations.total.toLocaleString()} eligible conversations`}
        </Typography>
    ) : null;

    return (
        <Grid>
            {titleComponent}
            {yComponent}
            {subTitleComponent}
            {eligibleComponent}
        </Grid>
    );
};
